export default __webpack_public_path__ + "static/media/SHOT1.26b3ae2f.png";